import EmailIntegrationPage from './EmailIntegrationPage';
export default EmailIntegrationPage;